// Overtime estimate (Phase 3d) — this month's attendance-derived overtime hours
// and estimated payable. Read-only; self (employeeId omitted) or HR.
import { useState, useEffect } from 'react';
import { Timer } from 'lucide-react';
import { Card, Pill } from './ui';
import { AG } from './theme/tokens';
import { api } from './api';

export default function OvertimeCard({ employeeId }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    (employeeId ? api.empOvertime(employeeId) : api.myOvertime()).then(setD).catch(() => setD(null));
  }, [employeeId]);

  if (!d) return null;
  const cur = d.currency || 'PKR';
  const money = (n) => `${cur} ${Number(n || 0).toLocaleString('en-IN')}`;

  return (
    <Card style={{ padding: 20 }}>
      <div className="flex items-center justify-between" style={{ marginBottom: 6 }}>
        <div className="flex items-center gap-2"><Timer size={17} style={{ color: AG.primary }} /><h3 style={{ fontWeight: 600, color: AG.text }}>Overtime · {d.month}</h3></div>
        <Pill tone={d.otHours > 0 ? 'info' : 'neutral'}>{d.otHours} hrs</Pill>
      </div>
      {d.otHours === 0 ? (
        <p style={{ fontSize: 13, color: AG.n500 }}>No overtime recorded this month.</p>
      ) : (
        <>
          <div className="flex items-center justify-between" style={{ fontSize: 14, padding: '9px 0', borderBottom: `1px solid ${AG.divider}` }}>
            <span style={{ color: AG.n500 }}>Overtime hours</span>
            <span style={{ color: AG.text, fontWeight: 500 }}>{d.otHours} hrs · {money(d.hourlyRate)}/hr base</span>
          </div>
          <div className="flex items-center" style={{ gap: 6, flexWrap: 'wrap', padding: '9px 0', borderBottom: `1px solid ${AG.divider}` }}>
            {[['weekday', 'Weekday'], ['weekend', 'Weekend'], ['holiday', 'Holiday']].map(([k, label]) =>
              d.byTier?.[k] > 0 ? <Pill key={k} tone="info">{label} {d.byTier[k]}h ×{d.multipliers?.[k]}</Pill> : null,
            )}
          </div>
          <div className="flex items-center justify-between" style={{ fontSize: 14, padding: '9px 0', borderTop: `2px solid ${AG.n200}`, marginTop: 4 }}>
            <span style={{ color: AG.n500 }}>Estimated overtime pay</span>
            <span style={{ color: AG.primary, fontWeight: 700 }}>{money(d.estimatedPay)}</span>
          </div>
        </>
      )}
    </Card>
  );
}
